import archive from './illustrativeIcons/icon-illustration-archive.svg';
import authorisation from './illustrativeIcons/icon-illustration-authorisation.svg';
import book from './illustrativeIcons/icon-illustration-book.svg';
import briefcase from './illustrativeIcons/icon-illustration-briefcase.svg';
import buildingAdministrative from './illustrativeIcons/icon-illustration-building-administrative.svg';
import buildings from './illustrativeIcons/icon-illustration-buildings.svg';
import catalog from './illustrativeIcons/icon-illustration-catalog.svg';
import chartAnalytics from './illustrativeIcons/icon-illustration-chart-analytics.svg';
import chartPie from './illustrativeIcons/icon-illustration-chart-pie.svg';
import chartScreen from './illustrativeIcons/icon-illustration-chart-screen.svg';
import chartStatistic from './illustrativeIcons/icon-illustration-chart-statistic.svg';
import chatBubbles from './illustrativeIcons/icon-illustration-chat-bubbles.svg';
import child from './illustrativeIcons/icon-illustration-child.svg';
import collaboration from './illustrativeIcons/icon-illustration-collaboration.svg';
import contract from './illustrativeIcons/icon-illustration-contract.svg';
import conversation from './illustrativeIcons/icon-illustration-conversation.svg';
import court from './illustrativeIcons/icon-illustration-court.svg';
import creditCards from './illustrativeIcons/icon-illustration-credit-cards.svg';
import database from './illustrativeIcons/icon-illustration-database.svg';
import display from './illustrativeIcons/icon-illustration-display.svg';
import doctor from './illustrativeIcons/icon-illustration-doctor.svg';
import environment from './illustrativeIcons/icon-illustration-environment.svg';
import exchange from './illustrativeIcons/icon-illustration-exchange.svg';
import failure from './illustrativeIcons/icon-illustration-failure.svg';
import family from './illustrativeIcons/icon-illustration-family.svg';
import faq from './illustrativeIcons/icon-illustration-faq.svg';
import feedback from './illustrativeIcons/icon-illustration-feedback.svg';
import finance from './illustrativeIcons/icon-illustration-finance.svg';
import folder from './illustrativeIcons/icon-illustration-folder.svg';
import global from './illustrativeIcons/icon-illustration-global.svg';
import group from './illustrativeIcons/icon-illustration-group.svg';
import growth from './illustrativeIcons/icon-illustration-growth.svg';
import handCoins from './illustrativeIcons/icon-illustration-hand-coins.svg';
import handPlate from './illustrativeIcons/icon-illustration-hand-plate.svg';
import helpdesk from './illustrativeIcons/icon-illustration-helpdesk.svg';
import home from './illustrativeIcons/icon-illustration-home.svg';
import house from './illustrativeIcons/icon-illustration-house.svg';
import idBadge from './illustrativeIcons/icon-illustration-id-badge.svg';
import laptopContent from './illustrativeIcons/icon-illustration-laptop-content.svg';
import laptop from './illustrativeIcons/icon-illustration-laptop.svg';
import leap from './illustrativeIcons/icon-illustration-leap.svg';
import magicWand from './illustrativeIcons/icon-illustration-magic-wand.svg';
import mailbox from './illustrativeIcons/icon-illustration-mailbox.svg';
import manButtons from './illustrativeIcons/icon-illustration-man-buttons.svg';
import manGlasses from './illustrativeIcons/icon-illustration-man-glasses.svg';
import manLaptop from './illustrativeIcons/icon-illustration-man-laptop.svg';
import map from './illustrativeIcons/icon-illustration-map.svg';
import messageSent from './illustrativeIcons/icon-illustration-message-sent.svg';
import messages from './illustrativeIcons/icon-illustration-messages.svg';
import meter from './illustrativeIcons/icon-illustration-meter.svg';
import migrationFinland from './illustrativeIcons/icon-illustration-migration-finland.svg';
import money from './illustrativeIcons/icon-illustration-money.svg';
import moneyBag from './illustrativeIcons/icon-illustration-money-bag.svg';
import organisation from './illustrativeIcons/icon-illustration-organisation.svg';
import phoneText from './illustrativeIcons/icon-illustration-phone-text.svg';
import phone from './illustrativeIcons/icon-illustration-phone.svg';
import piggyBank from './illustrativeIcons/icon-illustration-piggy-bank.svg';
import pillar from './illustrativeIcons/icon-illustration-pillar.svg';
import planeFlying from './illustrativeIcons/icon-illustration-plane-flying.svg';
import presentation from './illustrativeIcons/icon-illustration-presentation.svg';
import puzzle from './illustrativeIcons/icon-illustration-puzzle.svg';
import registers from './illustrativeIcons/icon-illustration-registers.svg';
import rocket from './illustrativeIcons/icon-illustration-rocket.svg';
import scaleBalance from './illustrativeIcons/icon-illustration-scale-balance.svg';
import scale from './illustrativeIcons/icon-illustration-scale.svg';
import server from './illustrativeIcons/icon-illustration-server.svg';
import settings from './illustrativeIcons/icon-illustration-settings.svg';
import shelter from './illustrativeIcons/icon-illustration-shelter.svg';
import shop from './illustrativeIcons/icon-illustration-shop.svg';
import smartwatch from './illustrativeIcons/icon-illustration-smartwatch.svg';
import socialSecurity from './illustrativeIcons/icon-illustration-social-security.svg';
import steering from './illustrativeIcons/icon-illustration-steering.svg';
import success from './illustrativeIcons/icon-illustration-success.svg';
import support from './illustrativeIcons/icon-illustration-support.svg';
import swim from './illustrativeIcons/icon-illustration-swim.svg';
import tabletText from './illustrativeIcons/icon-illustration-tablet-text.svg';
import tablet from './illustrativeIcons/icon-illustration-tablet.svg';
import team from './illustrativeIcons/icon-illustration-team.svg';
import touch from './illustrativeIcons/icon-illustration-touch.svg';
import train from './illustrativeIcons/icon-illustration-train.svg';
import userBadge from './illustrativeIcons/icon-illustration-user-badge.svg';
import userProfile from './illustrativeIcons/icon-illustration-user-profile.svg';
import webDevelopment from './illustrativeIcons/icon-illustration-web-development.svg';
import webService from './illustrativeIcons/icon-illustration-web-service.svg';
import womanButtons from './illustrativeIcons/icon-illustration-woman-buttons.svg';
import womanNecklace from './illustrativeIcons/icon-illustration-woman-necklace.svg';

export type IllustrativeIconKeys = keyof typeof illustrativeIcons;

export const illustrativeIcons = {
  archive,
  authorisation,
  book,
  briefcase,
  buildingAdministrative,
  buildings,
  catalog,
  chartAnalytics,
  chartPie,
  chartScreen,
  chartStatistic,
  chatBubbles,
  child,
  collaboration,
  contract,
  conversation,
  court,
  creditCards,
  database,
  display,
  doctor,
  environment,
  exchange,
  failure,
  family,
  faq,
  feedback,
  finance,
  folder,
  global,
  group,
  growth,
  handCoins,
  handPlate,
  helpdesk,
  home,
  house,
  idBadge,
  laptopContent,
  laptop,
  leap,
  magicWand,
  mailbox,
  manButtons,
  manGlasses,
  manLaptop,
  map,
  messageSent,
  messages,
  meter,
  migrationFinland,
  money,
  moneyBag,
  organisation,
  phoneText,
  phone,
  piggyBank,
  pillar,
  planeFlying,
  presentation,
  puzzle,
  registers,
  rocket,
  scaleBalance,
  scale,
  server,
  settings,
  shelter,
  shop,
  smartwatch,
  socialSecurity,
  steering,
  success,
  support,
  swim,
  tabletText,
  tablet,
  team,
  touch,
  train,
  userBadge,
  userProfile,
  webDevelopment,
  webService,
  womanButtons,
  womanNecklace
};
